/**
 * @author Kelnik
 *
 * SliderHistory - Слайдер с миниатюрками
 */

import 'slick-carousel/slick/slick.css';
import 'slick-carousel';
import SliderArrows from 'components/slider-arrows';

class SliderHistory {
    constructor(options) {
        this.options = options;
        this.container = options.container;
        this.arrowsSelector = '.j-slider-arrows';

        // main
        this.mainTrackSelector = '.j-slider-history-main-track';
        this.prevSelector = '.j-slider-history-prev';
        this.nextSelector = '.j-slider-history-next';

        // Thumbnail
        this.thumbTrackSelector = '.j-slider-history-thumb-track';

        // status
        this.currentIndex = 0;
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initElements();
        this._initSlider();
        this._initThumb();
        this._initArrows();
        this._bindEvents();
    }

    _initElements() {
        this.arrowsEl = this.container.querySelector(this.arrowsSelector);
        this.mainTrack = this.container.querySelector(this.mainTrackSelector);
        this.prev = this.container.querySelector(this.prevSelector);
        this.next = this.container.querySelector(this.nextSelector);
        this.thumbTrack = this.container.querySelector(this.thumbTrackSelector);
    }

    _initSlider() {
        this.slider = $(this.mainTrack);

        this.slider
            .on('swipe', () => {
                this.arrow.stopTimer();
            })
            .on('afterChange', (event, slick, currentSlide) => {
                if (!this.sliderThumb) {
                    return;
                }

                this.sliderThumb.slick('slickGoTo', currentSlide);

                this.sliderThumb.find('.slick-slide.is-active').removeClass('is-active');
                this.sliderThumb.find(`.slick-slide[data-slick-index="${currentSlide}"]`).addClass('is-active');

                this.currentIndex = currentSlide;
            })
            .slick({
                infinite      : false,
                slidesToShow  : 1,
                slidesToScroll: 1,
                adaptiveHeight: false,
                prevArrow     : this.prev,
                nextArrow     : this.next
            });
    }

    _initThumb() {
        this.sliderThumb = $(this.thumbTrack);

        this.sliderThumb
            .on('init breakpoint', () => {
                this.sliderThumb.find(`.slick-slide[data-slick-index="${this.currentIndex}"]`).addClass('is-active');

                this._bindEventsThumb();
            })
            .on('swipe', () => {
                this.arrow.stopTimer();
            })
            .slick({
                infinite      : false,
                slidesToShow  : 5,
                slidesToScroll: 3,
                arrows        : false,
                adaptiveHeight: false,
                responsive    : [{
                    breakpoint: 960,
                    settings  : {slidesToShow: 5}
                }, {
                    breakpoint: 670,
                    settings  : {slidesToShow: 3}
                }]
            });
    }

    _initArrows() {
        if (!this.slider) {
            return;
        }

        this.arrow = new SliderArrows({
            container: this.arrowsEl,
            timeout  : this._nextSlide.bind(this)
        });

        this.arrow.init();
    }

    /* eslint-disable */
    _bindEvents() {

    }

    _bindEventsThumb() {
        const slides = Array.from(this.thumbTrack.querySelectorAll('.slick-slide'));

        slides.forEach((slide) => {
            slide.addEventListener('click', () => {
                if (!this.slider) {
                    return;
                }

                const index = slide.dataset.slickIndex;

                this.slider.slick('slickGoTo', index);
                this.arrow.stopTimer();

                this.currentIndex = index;
            });
        });
    }

    _nextSlide() {
        const count = this.slider.slick('getSlick').slideCount;

        if (this.currentIndex + 1 === count) {
            this.slider.slick('slickGoTo', 0);
        } else {
            this.slider.slick('slickNext');
        }
    }
}

export default SliderHistory;
